import { combineReducers } from 'redux'

import authActions from './auth/actions'
import authReducer, { initialState as authInitialState } from './auth/reducer'
import type { AuthReducerAction } from './auth/types'
import controlsReducer, { initialState as controlsInitialState } from './controls/reducer'
import type { ControlsReducerAction } from './controls/types'
import dashboardReducer, { initialState as dashboardInitialState } from './dashboard/reducer'
import type { DashboardReducerAction } from './dashboard/types'
import dokumentsReducer, { initialState as dokumentsInitialState } from './dokuments/reducer'
import type { DokumentReducerAction } from './dokuments/types'
import expenseReducer, { initialState as expenseInitialState } from './expense/reducer'
import type { ExpenseReducerAction } from './expense/types'
import filtersReducer, { initialState as filtersInitialState } from './filters/reducer'
import incomeReducer, { initialState as incomeInitialState } from './income/reducer'
import type { IncomeReducerAction } from './income/types'
import type { LocaleReducerAction } from './locale/reducer'
import localeReducer, { initialState as localeInitialState } from './locale/reducer'
import messageToAccountantReducer, {
  initialState as messageToAccountantInitialState,
} from './messageToAccountant/reducer'
import type { MessageToAccountantReducerAction } from './messageToAccountant/types'
import type { PartnerReducerAction } from './partners/reducer'
import partnersReducer, { initialState as partnersInitialState } from './partners/reducer'
import paymentReducer, { initialState as paymentInitialState } from './payment/reducer'
import type { PaymentReducerAction } from './payment/types'
import quarantineReducer, { initialState as quarantineInitialState } from './quarantine/reducer'
import type { QuarantineReducerAction } from './quarantine/types'
import type { TaxReducerAction } from './tax/reducer'
import taxReducer, { initialState as taxInitialState } from './tax/reducer'
import taxationDetailsReducer, { initialState as taxationDetailsInitialState } from './taxationDetails/reducer'
import type { TaxationDetailsReducerAction } from './taxationDetails/types'

export type AllAction =
  | AuthReducerAction
  | ControlsReducerAction
  | DashboardReducerAction
  | DokumentReducerAction
  | ExpenseReducerAction
  | IncomeReducerAction
  | LocaleReducerAction
  | MessageToAccountantReducerAction
  | PartnerReducerAction
  | PaymentReducerAction
  | QuarantineReducerAction
  | TaxReducerAction
  | TaxationDetailsReducerAction

const initialState: RootStore = {
  auth: authInitialState,
  controls: controlsInitialState,
  dashboard: dashboardInitialState,
  dokuments: dokumentsInitialState,
  expense: expenseInitialState,
  filters: filtersInitialState,
  income: incomeInitialState,
  locale: localeInitialState,
  messageToAccountant: messageToAccountantInitialState,
  partners: partnersInitialState,
  payment: paymentInitialState,
  quarantine: quarantineInitialState,
  tax: taxInitialState,
  taxationDetails: taxationDetailsInitialState,
}

const appReducer = combineReducers({
  auth: authReducer,
  controls: controlsReducer,
  dashboard: dashboardReducer,
  dokuments: dokumentsReducer,
  expense: expenseReducer,
  filters: filtersReducer,
  income: incomeReducer,
  locale: localeReducer,
  messageToAccountant: messageToAccountantReducer,
  partners: partnersReducer,
  payment: paymentReducer,
  quarantine: quarantineReducer,
  tax: taxReducer,
  taxationDetails: taxationDetailsReducer,
})

const rootReducer = (state: RootStore = initialState, action: AllAction) => {
  if (action.type === authActions.logout.SUCCESS) {
    // reset all reducer state to initial after logout except dashboard.common part
    state = {
      ...initialState,
      dashboard: {
        ...initialState.dashboard,
        common: state?.dashboard?.common ?? initialState.dashboard.common,
      },
    }
  }

  return appReducer(state, action)
}

export default rootReducer
